export class APIConstant {

  public static INQUIRY      = '/inquiry';
  public static PAYMENT      = '/payment';

  public static BNI_SNAP_INQUIRY      = 'bni-snap/inquiry';
  public static BNI_SNAP_PAYMENT      = 'bni-snap/payment';

  public static DANAMON_INQUIRY      = 'danamon/inquiry';
  public static DANAMON_PAYMENT      = 'danamon/payment';

  public static DANAMON_SNAP_INQUIRY      = 'danamon-snap/inquiry';
  public static DANAMON_SNAP_PAYMENT      = 'danamon-snap/payment';

  public static MANDIRI_INQUIRY      = 'mandiri/inquiry';
  public static MANDIRI_PAYMENT      = 'mandiri/payment';

  public static MANDIRI_SNAP_INQUIRY      = 'mandiri-snap/inquiry';
  public static MANDIRI_SNAP_PAYMENT      = 'mandiri-snap/payment';

  public static MANDIRISYARIAH_INQUIRY      = 'mandiriSyariah/inquiry';
  public static MANDIRISYARIAH_PAYMENT      = 'mandiriSyariah/payment';

  public static BRISYARIAH_INQUIRY      = 'briSyariah/inquiry';
  public static BRISYARIAH_PAYMENT      = 'briSyariah/payment';

  public static PERMATA_INQUIRY      = 'permata/inquiry';
  public static PERMATA_PAYMENT      = 'permata/payment ';

  public static BCA_INQUIRY          = 'bca/inquiry';
  public static BCA_PAYMENT          = 'bca/payment';

  public static OVO_INQUIRY          = 'ovosimulator/ovoProcess';
  public static OVO_PAYMENT          = 'ovosimulator/resultStatus';

  public static DOKUVA_INQUIRY      = 'doku-va/inquiry';
  public static DOKUVA_PAYMENT      = 'doku-va/payment';

  public static ALFA_INQUIRY      = 'alfamart/inquiry';
  public static ALFA_PAYMENT      = 'alfamart/payment';

  public static INDOMARET_INQUIRY      = 'indomaret/inquiry';
  public static INDOMARET_PAYMENT      = 'indomaret/payment';

  public static BRI_INQUIRY      = 'bri/inquiry';
  public static BRI_PAYMENT      = 'bri/payment';

  public static BRI_SNAP_INQUIRY      = 'bri-snap/inquiry';
  public static BRI_SNAP_PAYMENT      = 'bri-snap/payment';

  public static BTN_INQUIRY      = 'btn/inquiry';
  public static BTN_PAYMENT      = 'btn/payment';

  public static SHOPEEPAY_PAYMENT      = 'v1/shopeepay/payment';
  public static BNI_PAYMENT_NOTIFICATION = 'bni/payment-notification';

  public static BNC_PAYMENT_NOTIFICATION = 'bnc/payment-notification';

  public static PERMATA_SNAP_INQUIRY      = 'permata-snap/inquiry';
  public static PERMATA_SNAP_PAYMENT      = 'permata-snap/payment';

  public static MAYBANK_SNAP_INQUIRY      = 'maybank-snap/inquiry';
  public static MAYBANK_SNAP_PAYMENT      = 'maybank-snap/payment';

  public static KLIKBCA_INQUIRY = 'klikbca/inquiry';
  public static KLIKBCA_PAYMENT = 'klikbca/payment';

  public static BSI_SNAP_INQUIRY      = 'bsi-snap/inquiry';
  public static BSI_SNAP_PAYMENT      = 'bsi-snap/payment';

}
